export class UserToken {
	commonName: string;
	authTime: Date;
	emailAddress: string;
	givenName: string;
	sub: string;
	surName: string;
	country: string;
	cdsid: string;
}